var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 13.75V50C55.5 55.5 51 60 45.5 60H27.25C24.55 60 22 58.925 20.125 57.025L0.5 37.075C0.5 37.075 3.65 34 3.75 33.95C4.3 33.475 4.975 33.225 5.725 33.225C6.275 33.225 6.775 33.375 7.225 33.625C7.325 33.65 18 39.775 18 39.775V10C18 7.925 19.675 6.25 21.75 6.25C23.825 6.25 25.5 7.925 25.5 10V27.5H28V3.75C28 1.675 29.675 0 31.75 0C33.825 0 35.5 1.675 35.5 3.75V27.5H38V6.25C38 4.175 39.675 2.5 41.75 2.5C43.825 2.5 45.5 4.175 45.5 6.25V27.5H48V13.75C48 11.675 49.675 10 51.75 10C53.825 10 55.5 11.675 55.5 13.75Z",
    fill: "#fd8d8d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopHand);
export default __webpack_public_path__ + "static/media/stopHand.8bd0dd7cd03181cb09c03f17f69b5323.svg";
export { ForwardRef as ReactComponent };